export default __webpack_public_path__ + "static/media/Algo.69a0226e.png";